import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { BaseComponent } from 'src/app/core/base.component';
import { StateDto } from 'src/app/shared/models/state.dto';
import { SessionService } from 'src/app/shared/services/session.service';
import { Course } from '../course';
import { CourseQueryFilter } from '../course-query-filter';
import { CourseService } from '../course.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-courses-list',
    templateUrl: './courses-list.component.html',
    styleUrls: ['./courses-list.component.scss'],
    standalone: false
})
export class CoursesListComponent extends BaseComponent implements OnInit {
  @Input() filter: CourseQueryFilter = new CourseQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public courses: Course[] = [];
  public states: StateDto[] = [];


  constructor(public sessionService: SessionService,
    private courseService: CourseService, 
    stringHelpers: StringHelpers) { 
    super(sessionService, stringHelpers);
    this.filter.pageSize = 10;
    this.displayedColumns = ['name', 'shortName', 'edit'];
    this.states.push({state: "MI"});
  }

  ngOnInit(): void {
  }

  onStateSelection(){
    this.getCourses();
  }

  getCourses(){
    this.isLoading = true;
    this.filter.state = this.stateDto.state;
    this.courseService.getCoursesByState(this.filter).subscribe(results => {
      this.courses = results.results;
      this.filter.totalCount = results.totalCount;
      this.updateFilterEvent.emit(results.results);
      this.isLoading = false;
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 10;
  }

}
